import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-product-strip-section',
  templateUrl: './product-strip-section.component.html',
  styleUrl: './product-strip-section.component.scss',
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class ProductStripSectionComponent {}
